import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a1628] border-t border-[#1a2840] text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_skilled-talent/artifacts/3crk5kcm_31810.jpg" 
              alt="Service2Success Talent Solutions" 
              className="h-16 mb-4"
            />
            <p className="text-sm text-gray-400 mb-4">
              Translating Experience into Career Success
            </p>
            <p className="text-sm text-gray-400">
              Veteran-Focused Direct-Hire Recruiting for Engineering, Manufacturing, & Operations
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-[#d4a574] transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-[#d4a574] transition-colors">About</Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-[#d4a574] transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/industries" className="hover:text-[#d4a574] transition-colors">Industries</Link>
              </li>
              <li>
                <Link to="/why-us" className="hover:text-[#d4a574] transition-colors">Why Work With Us</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#d4a574] transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-[#d4a574] transition-colors">Direct Hire Recruiting</li>
              <li className="hover:text-[#d4a574] transition-colors">Veteran Hiring Solutions</li>
              <li className="hover:text-[#d4a574] transition-colors">Candidate Support</li>
              <li className="hover:text-[#d4a574] transition-colors">Resume Optimization</li>
              <li className="hover:text-[#d4a574] transition-colors">SkillBridge Partnerships</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#d4a574] flex-shrink-0 mt-0.5" />
                <span>Batesville, Indiana</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-[#d4a574] flex-shrink-0" />
                <a href="tel:513-668-0344" className="hover:text-[#d4a574] transition-colors">
                  513-668-0344
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-[#d4a574] flex-shrink-0" />
                <a href="mailto:rich@s2stalent.com" className="hover:text-[#d4a574] transition-colors">
                  rich@s2stalent.com
                </a>
              </li>
            </ul>
            <div className="mt-6">
              <p className="text-xs text-gray-400 mb-2">Serving:</p>
              <p className="text-xs text-gray-400">
                Cincinnati • Indianapolis • Tri-State Region • Nationwide
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-[#1a2840] mt-12 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {currentYear} Service2Success Talent Solutions. All rights reserved.
          </p>
          <p className="text-xs text-gray-500 mt-2">
            Veteran-Owned Business | Proudly serving America's employers and veterans
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
